import PropTypes from 'prop-types'
import React from 'react'
import { classes } from '../utils/components'
import TextBlock from './text-block'

/**
 * Simple block that contains optional title and optional description
 */
const SimpleBlock = ({
  className,
  centered = true,
  title,
  description,
  titleClass,
  descriptionClass,
  titleColorClass,
  descriptionColorClass,
}) => (
  <div
    className={classes(
      'container w-full flex flex-col items-start',
      centered && 'md:items-center',
      className
    )}
  >
    {title && (
      <h2
        className={classes(
          centered && 'md:text-center',
          titleClass,
          titleColorClass
        )}
      >
        {title}
      </h2>
    )}
    {description && (
      <TextBlock
        className={classes(
          centered && 'md:text-center',
          'mt-8 first:mt-0',
          descriptionClass
        )}
        colorClass={descriptionColorClass}
        text={description}
      ></TextBlock>
    )}
  </div>
)

SimpleBlock.propTypes = {
  className: PropTypes.string,
  centered: PropTypes.bool,
  titleColorClass: PropTypes.string,
  descriptionColorClass: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.object,
}

export default SimpleBlock
